import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";
import config from "../config/config";

const InvoiceContext = createContext();

export const InvoiceProvider = ({ children }) => {
  const [invoicesData, setInvoicesData] = useState([]);

  const fetchAllInvoices = useCallback(async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/v1/invoices`);
      const sortedInvoices = response.data.sort(
        (a, b) => new Date(b.created * 1000) - new Date(a.created * 1000)
      );
      setInvoicesData((prevData) =>
        mergeInvoicesData(prevData, sortedInvoices)
      );
    } catch (error) {
      console.error("Failed to fetch invoices", error);
    }
  }, []);

  const fetchInvoiceById = async (invoiceId) => {
    try {
      const response = await axios.get(
        `${config.API_BASE_URL}/v1/invoices/${invoiceId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching invoice:", error);
      return null;
    }
  };

  const mergeInvoicesData = (prevData, newData) => {
    const newDataIds = new Set(newData.map((invoice) => invoice.id));
    const filteredPrevData = prevData.filter(
      (invoice) => !newDataIds.has(invoice.id)
    );
    return [...filteredPrevData, ...newData];
  };

  useEffect(() => {
    fetchAllInvoices();
  }, [fetchAllInvoices]);

  return (
    <InvoiceContext.Provider
      value={{
        invoicesData,
        setInvoicesData,
        fetchAllInvoices,
        fetchInvoiceById,
      }}
    >
      {children}
    </InvoiceContext.Provider>
  );
};

export const useInvoice = () => useContext(InvoiceContext);
